import { createFileRoute } from "@tanstack/react-router"

import config from "@/config"

import { ExpensesPage } from "../components/books/expenses-page"

export const Route = createFileRoute("/_app-shell/expenses")({
  head: () => ({
    meta: [
      { title: `Expenses - ${config.core.projectName}` },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ExpensesPage,
})
